import React, { useEffect, useState } from "react";
import ButtonContainer from "../../../Components/CheckableButton/ButtonContainer";
import CheckableButton from "../../../Components/CheckableButton/CheckableButton";
import { API } from "../../../API";
import { connect } from "react-redux";
import { APIMETHOD } from "../../../v2/API";
import { customer } from "../../../v2/endpoints/customer";
import moment from "moment/moment";

const FinanceSetting = (props) => {
    const { institution } = props;
    const college = JSON.parse(JSON.parse(window.localStorage['persist:root']).college);
    const [isPaymentDateCheck, setIsPaymentDateCheck] = useState("");
    const [isPaymentNotiCheck, setIsPaymentNotiCheck] = useState("");
    const [dateGroupA, setDateGroupA] = useState("");
    const [dateGroupB, setDateGroupB] = useState("");
    const [listPersonnelAndCampusesName, setListPersonnelAndCampusesName] = useState([]);
    const [data, setData] = useState([]);

    useEffect(() => {
        API.getInstitutionById(institution._id)
            .then(result => {
                const invoiceSetting = result?.data?.data[0];
                setData(invoiceSetting);
                if (invoiceSetting) {
                    setIsPaymentDateCheck(invoiceSetting?.payment_setting?.payment_date_option);
                    setIsPaymentNotiCheck(invoiceSetting?.notification_setting?.notification_option);
                    setListPersonnelAndCampusesName(invoiceSetting.notification_setting?.personnel_campuses);
                }
            }).catch((err) => {
                console.log(err)
            }
            );
        fetchPaymentDate();
    }, []);

    const fetchPaymentDate = () => {
        APIMETHOD.get(customer.fetchPaymentDateForToday, {}).then(result => {
            if (result?.data?.length > 0) {
                result.data.forEach(item => {
                    if (item.belongs_to_group == 'Group A') {
                        setDateGroupA(item);
                    } else {
                        setDateGroupB(item);
                    }
                });
            }
        });
    }

    return (
        <div className="container college-info">
                    <ButtonContainer
                        className="row mt-3 mb-3"
                        twoColumns
                        vertical
                    >
                        <label>Group A</label>
                        <CheckableButton
                            className="col-6 form-check mb-2 pt-2 pb-2"
                            value="payment-date-1"
                            checked={isPaymentDateCheck === 'payment-date-1'}
                            name="paymentRadio" id="paymentRadio1"
                        >
                            Invoice Delivery Date {dateGroupA?.fortnight_end_date ? moment(dateGroupA?.fortnight_end_date, 'DD/MM/YYYY').format('DD MMM YYYY') : ''}
                            <br />
                            For teaching period {dateGroupA?.fortnight_start_date ? moment(dateGroupA?.fortnight_start_date, 'DD/MM/YYYY').format('DD MMM YYYY') : ''} -  {dateGroupA?.fortnight_end_date ? moment(dateGroupA?.fortnight_end_date, 'DD/MM/YYYY').format('DD MMM YYYY') : ''}
                            <br />
                            <h4>Payment date  {dateGroupA?.teachers_payment_date ? moment(dateGroupA?.teachers_payment_date, 'DD/MM/YYYY').format('DD MMM YYYY') : ''}</h4>
                        </CheckableButton>
                        <label>Group B</label>
                        <CheckableButton
                            className="col-6 form-check mb-2 pt-2 pb-2"
                            name="paymentRadio"
                            id="paymentRadio2"
                            value="payment-date-2"
                            checked={isPaymentDateCheck === 'payment-date-2'}
                        >
                            Invoice Delivery Date {dateGroupB?.fortnight_end_date ? moment(dateGroupB?.fortnight_end_date, 'DD/MM/YYYY').format('DD MMM YYYY') : ''}
                            <br />
                            For teaching period  {dateGroupB?.fortnight_start_date ? moment(dateGroupB?.fortnight_start_date, 'DD/MM/YYYY').format('DD MMM YYYY') : ''} -  {dateGroupB?.fortnight_end_date ? moment(dateGroupB?.fortnight_end_date, 'DD/MM/YYYY').format('DD MMM YYYY') : ''}
                            <br />
                            <h4>Payment date {dateGroupB?.teachers_payment_date ? moment(dateGroupB?.teachers_payment_date, 'DD/MM/YYYY').format('DD MMM YYYY') : ''}</h4>
                        </CheckableButton>
                    </ButtonContainer>
                    <p className="college-form-label">Invoice notification options</p>
                    <ButtonContainer
                        className="row mt-3 mb-3"
                        twoColumns
                        vertical
                    >
                        <CheckableButton
                            value={"option-myself"}
                            className="mb-2 text-wrap"
                            name="notiOption" id="notiOption1"
                            checked={isPaymentNotiCheck === 'option-myself'}
                        >
                            I approve & forward to my finance department for payment processing
                        </CheckableButton>
                        <div>
                            <CheckableButton
                                value={"option-finance-team"}
                                className="mb-2 text-wrap"
                                name="notiOption" id="notiOption2"
                                checked={isPaymentNotiCheck === 'option-finance-team'}
                            >
                                My finance department both approves and processes payment
                            </CheckableButton>
                        </div>
                        <CheckableButton
                            value={"option-personnel-view"}
                            className="mb-2 text-wrap"
                            name="notiOption" id="notiOption3"
                            checked={isPaymentNotiCheck === 'option-personnel-view'}
                        >
                            I select personnel to view specific campus invoices
                        </CheckableButton>
                        <CheckableButton
                            value={"option-personnel"}
                            className="mb-2 text-wrap"
                            name="notiOption" id="notiOption4"
                            checked={isPaymentNotiCheck === 'option-personnel'}
                        >
                            I nominate personnel to approve specific campus invoices
                            <br />
                            {isPaymentNotiCheck && isPaymentNotiCheck === 'option-personnel' && (
                                listPersonnelAndCampusesName?.map(item => {
                                    const personnel = data?.personnels?.find(personnel => personnel._id === item.personnel_id);
                                    const personnelName = personnel?.personnel_first_name +
                                    ' ' +
                                    personnel?.personnel_last_name;
                                    const campuses = item.campuses.map(campusId => {
                                        const campus = data?.campuses?.find(value => value._id === campusId);
                                        return campus ? (
                                            campus.address_line1 +
                                            (campus.address_line2 ? ', ' + campus.address_line2 : '') +
                                            ', ' +
                                            campus.suburb
                                        ) : '';
                                    });

                                    return (
                                        <>
                                            <small>
                                                {
                                                    (item.personnel_id == data?.customer?._id ? (data?.customer.first_name + ' ' + data?.customer.last_name)  : personnelName) +
                                                    ' - ' +
                                                    (campuses.length === college?.campuses?.length ? 'All campuses' : 
                                                    campuses.join(' - '))
                                                }
                                            </small>
                                            <br />
                                        </>
                                    );
                                })
                            )}

                        </CheckableButton>
                    </ButtonContainer>
                </div>
    );
}

export default connect(null, null)(FinanceSetting);